<template>
    <b-dropdown class="mx-1" right size="sm" variant="secondary">
        <template #button-content>
            <i class="lar la-copy"></i>
        </template>
        <template v-if="!isEmpty(index)">
            <b-dropdown-item @click="copyTo">Copia riga singola</b-dropdown-item>
        </template>
        <!--         - copy warranty from to selected province.
                     - copy to the whole region
                     - copy to all available province-->
        <template v-else>
            <b-dropdown-item @click="copyTo">Copia garanzie a:</b-dropdown-item>
            <b-dropdown-item @click="copyToWholeRegion">Copia in tutta la regione</b-dropdown-item>
            <b-dropdown-item @click="copyToAllProvince">Copia in tutte le province disponibili</b-dropdown-item>
        </template>
    </b-dropdown>
</template>
<script>
import SelectProvincesDialog from "./SelectProvincesDialog";
import {cloneDeep} from "lodash";
import isEmpty from "@/commons/isEmpty";
import store from "./store";

export default {
    name: 'btn-copy-product',
    props: {
        value: {},
        province_name: {},
        index: {},
    },
    methods: {
        isEmpty,
        async copyTo() {
            let response = await this.$dialogs.showComponent(SelectProvincesDialog)
            if (response.trigger !== 'ok') return
            this.copy(response.value)
        },
        copyToWholeRegion() {
            const province = store.provinces.find(p => p.belong_to === this.province_name)
            store.provincesByRegionCode[province.region_code].forEach(p => {
                this.copyToProvince(p.belong_to)
            })
        },
        copyToAllProvince() {
            store.provinces.forEach(p => {
                this.copyToProvince(p.belong_to)
            })
        },
        copy(dest) {
            if (isEmpty(dest)) return
            dest.forEach(place => {
                if (place.is_region) {
                    place.children.forEach(p => {
                        this.copyToProvince(p.id)
                    })
                } else {
                    this.copyToProvince(place.id)
                }
            })
        },
        copyToProvince(province_name) {
            const sourceProducts = this.value[this.province_name];
            const sourceProduct = !isEmpty(this.index) ? sourceProducts[this.index] : null;

            if (sourceProduct) {
                const existingProductIndex = this.value[province_name].findIndex(r =>
                    r.tariffa_codice === sourceProduct.tariffa_codice && r.warranty_codice === sourceProduct.warranty_codice
                );

                if (this.province_name !== province_name) {
                    if (existingProductIndex !== -1) {
                        this.$set(this.value[province_name], existingProductIndex, { ...sourceProduct });
                    } else {
                        this.value[province_name].push(cloneDeep(sourceProduct));
                    }
                } else {
                    if (existingProductIndex === -1) {
                        this.value[province_name].push(cloneDeep(sourceProduct));
                    }
                }
            } else {
                this.$set(this.value, province_name, cloneDeep(sourceProducts));
            }
        }
    }
}
</script>
